import { Container, Row, Col } from "react-bootstrap";
import CartHeader from "./CartHeader";
import TyreBody from "./TyreBody";
import QuotationForm from "./QuotationForm";
import Scrollbars from "react-custom-scrollbars";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

const QuoteThankYou = ({
  apiData,
  getModel,
  globalData,
  getCarBrandModal,
  cart,
}) => {
  const [filter, setFilter] = useState(0);

  return (
    <div style={{ paddingTop: "80px", overflow: "hidden" }}>
      <Scrollbars
        //   className="px-4 quotation"
        style={{ height: "calc(100vh - 200px)", width: "100%" }}
      >
        <Container fluid className="text-center">
          <Row
            className="thank-you-bg justify-content-center align-items-center"
            style={{ height: "200px" }}
          >
            <img src="/assets/thank-you-man.svg" alt="thank-you" height={110} />
          </Row>
          <Row>
            <Col>
              <h1>Thank You</h1>
              <h5>We Will Contact You Shortly!</h5>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center mt-5">
            <Col md={10}>
              <p className="text-black">
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
                commodo ligula eget dolor. Aenean massa. Cum sociis natoque
                penatibus et magnis dis parturient montes, nascetur ridiculus
                mus.
              </p>
            </Col>
          </Row>
        </Container>
      </Scrollbars>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuoteThankYou);
